/* eslint-disable no-useless-escape */
import {
    ButtonPrimary,
    Text3,
    ButtonFixedFooterLayout,
    PhoneNumberField,
    EmailField,
    skinVars,
    IconInformationUserRegular,
    Callout,
    useWindowSize,
    Text1,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './index.scss';
import { useTranslation } from 'react-i18next';
import { getCustomerData, updateCustomerData } from '../../../../../services/CustomerService';
import { setInfoError } from '../../../../../utils/dataTransformation/errorMesssages';
import { TrackingEvents } from '../../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../../utils/navigation/controlDevices';
import { AxiosError } from 'axios';
import HeaderProfile from '../../../../../components/HeaderProfile';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export const UpdatePersonalData: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { trackingScreenView } = new TrackingEvents();
    const flow = params.get('flow')!;
    const fromOnboarding = params.get('fromOnboarding')!;
    const [valueMobile, setValueMobile] = useState<string>('');
    const [valueEmail, setValueEmail] = useState<string>('');
    const [checkButton, setCheckButton] = useState<boolean>(false);
    const size = useWindowSize();
    const queryClient = useQueryClient();

    const { data: personalData } = useQuery(['customer-data'], getCustomerData);

    const validateEmail = () => {
        let aux: boolean;
        const validRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (valueEmail.match(validRegex)) {
            aux = true;
        } else {
            aux = false;
        }
        return aux;
    };

    const personalDataInput = () => {
        if (valueEmail === '') {
            return { contactNumber: valueMobile };
        } else if (valueMobile === '') {
            return { email: valueEmail };
        }
        return {};
    };

    const handleNavigate = (url: string, description: string, err?: any) => {
        if (url === '/contacts/verify') {
            navigate(url + '?flow=' + flow + '&contact=' + `${flow === 'mobile' ? valueMobile : valueEmail}`);
        } else {
            if (fromOnboarding === 'true') {
                navigate(url, {
                    state: {
                        err,
                        typeVerification: flow,
                        stateFeedback: description,
                    },
                });
            } else {
                navigate(url, {
                    state: {
                        fromOnboarding: fromOnboarding,
                        err,
                        typeVerification: flow,
                        stateFeedback: description,
                    },
                });
            }
        }
    };

    const getInfoCostumerDataUpdate = () => {
        updateCustomerData(personalDataInput())
            .then(() => {
                queryClient.removeQueries(['customer-data']);
                handleNavigate('/contacts/verify', 'SUCCESS');
            })
            .catch((error: AxiosError) => {
                const { id, httpCode } = setInfoError(error);
                if (httpCode !== 401 && id !== 'X401502') {
                    handleNavigate(
                        '/profile/personal-data/change/feedback',
                        'ERROR',

                        setInfoError(error),
                    );
                }
            });
    };

    useEffect(() => {
        if (flow === 'mobile') {
            setCheckButton(
                !valueMobile ||
                    (valueMobile && valueMobile.length !== 9) ||
                    (personalData?.data.contactNumber?.verified! &&
                        personalData?.data.contactNumber?.value === valueMobile),
            );
        } else if (flow === 'email') {
            setCheckButton(
                !validateEmail() ||
                    (personalData?.data.email?.verified! && personalData?.data.email?.value === valueEmail),
            );
        }
    }, [valueMobile, valueEmail]);

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <div className='update-personal-data'>
            <HeaderProfile
                title={flow === 'mobile' ? t('personalDataUpdateMobileTitle') : t('personalDataUpdateEmailTitle')}
                breadcrumbs={[
                    { title: t('profileTitle'), url: '/profile' },
                    { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                ]}
            />
            {size.width >= 768 ? (
                <div className='update-personal-data__wrapper'>
                    {size.width >= 1024 && (
                        <div className='update-personal-data__wrapper__title'>
                            <Text1 regular color={skinVars.colors.textSecondary}>
                                {flow === 'mobile'
                                    ? t('personalDataUpdateMobileTitle').toUpperCase()
                                    : t('personalDataUpdateEmailTitle').toUpperCase()}
                            </Text1>
                        </div>
                    )}

                    <div className='update-personal-data__wrapper__subtitle'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {flow === 'mobile' ? t('titleUpdatePersonalDataMobile') : t('titleUpdatePersonalDataEmail')}
                        </Text3>
                    </div>
                    <div className='update-personal-data__wrapper__inputField'>
                        {flow === 'mobile' ? (
                            <PhoneNumberField
                                value={valueMobile}
                                fullWidth={true}
                                name='phone'
                                label={t('mobile')}
                                onChangeValue={setValueMobile}
                                prefix='+34'
                                error={
                                    personalData?.data.contactNumber?.verified &&
                                    personalData?.data.contactNumber?.value === valueMobile
                                        ? true
                                        : false
                                }
                                helperText={
                                    personalData?.data.contactNumber?.verified &&
                                    personalData?.data.contactNumber?.value === valueMobile
                                        ? t('UpdatePersonalDataHelperTextMobile')
                                        : ''
                                }
                            />
                        ) : (
                            <EmailField
                                fullWidth={true}
                                value={valueEmail}
                                name='email'
                                label={t('UpdatePersonalDataLabelEmail')}
                                onChangeValue={setValueEmail}
                                error={
                                    personalData?.data.email?.verified && personalData?.data.email?.value === valueEmail
                                        ? true
                                        : false
                                }
                                helperText={
                                    personalData?.data.email?.verified && personalData?.data.email?.value === valueEmail
                                        ? t('UpdatePersonalDataHelperTextEmail')
                                        : t('personalDataHelperTextEmail')
                                }
                            />
                        )}
                    </div>
                    <div className='update-personal-data__wrapper__callout'>
                        <Callout
                            description={t('descriptionCalloutUpdateContact')}
                            icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
                        ></Callout>
                    </div>
                    <div className='update-personal-data__wrapper__btn'>
                        <ButtonPrimary
                            disabled={checkButton}
                            onPress={() => {
                                getInfoCostumerDataUpdate();
                            }}
                        >
                            {t('continue')}
                        </ButtonPrimary>
                    </div>
                </div>
            ) : (
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            disabled={checkButton}
                            onPress={() => {
                                getInfoCostumerDataUpdate();
                            }}
                        >
                            {t('continue')}
                        </ButtonPrimary>
                    }
                >
                    <div className='update-personal-data__wrapper'>
                        <div className='update-personal-data__wrapper__subtitle'>
                            <Text3 regular color={skinVars.colors.textPrimary}>
                                {flow === 'mobile'
                                    ? t('titleUpdatePersonalDataMobile')
                                    : t('titleUpdatePersonalDataEmail')}
                            </Text3>
                        </div>
                        <div className='update-personal-data__wrapper__inputField'>
                            {flow === 'mobile' ? (
                                <PhoneNumberField
                                    value={valueMobile}
                                    name='phone'
                                    label={t('mobile')}
                                    onChangeValue={setValueMobile}
                                    prefix='+34'
                                    error={
                                        personalData?.data.contactNumber?.verified &&
                                        personalData?.data.contactNumber?.value === valueMobile
                                            ? true
                                            : false
                                    }
                                    helperText={
                                        personalData?.data.contactNumber?.verified &&
                                        personalData?.data.contactNumber?.value === valueMobile
                                            ? t('UpdatePersonalDataHelperTextMobile')
                                            : ''
                                    }
                                />
                            ) : (
                                <EmailField
                                    value={valueEmail}
                                    name='email'
                                    label={t('UpdatePersonalDataLabelEmail')}
                                    onChangeValue={setValueEmail}
                                    error={
                                        personalData?.data.email?.verified &&
                                        personalData?.data.email?.value === valueEmail
                                            ? true
                                            : false
                                    }
                                    helperText={
                                        personalData?.data.email?.verified &&
                                        personalData?.data.email?.value === valueEmail
                                            ? t('UpdatePersonalDataHelperTextEmail')
                                            : t('personalDataHelperTextEmail')
                                    }
                                />
                            )}
                        </div>
                        <div className='update-personal-data__wrapper__callout'>
                            <Callout
                                description={t('descriptionCalloutUpdateContact')}
                                icon={<IconInformationUserRegular color={skinVars.colors.brand} />}
                            ></Callout>
                        </div>
                    </div>
                </ButtonFixedFooterLayout>
            )}
        </div>
    );
};

export default UpdatePersonalData;
